import { BehaviorSubject, Observable } from 'rxjs';

const Loader$ = new BehaviorSubject({ status: false, message: '' });

export function start(message: string = 'Carregando...'): void {
  Loader$.next({ status: true, message });
}

export function stop(): void {
  Loader$.next({ status: false, message: '' });
}

export function get(): Observable<any> {
  return Loader$;
}
